import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
  computed,
  DestroyRef,
  effect,
  inject,
  Injectable,
  signal,
  WritableSignal,
} from '@angular/core';
import {
  BehaviorSubject,
  catchError,
  finalize,
  map,
  Observable,
  of,
  ReplaySubject,
  Subject,
  switchMap,
  tap,
} from 'rxjs';
import { Router } from '@angular/router';
import { LoginUser, LoginResponse } from '../../interfaces/auth/auth';
import { LayoutService } from '../layout.service';
import { environment } from '../../../environments/environment';
import { jwtDecode } from 'jwt-decode';
@Injectable({
  providedIn: 'root',
})
export class AuthService {
  readonly httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Cache-Control':
        'no-cache, no-store, must-revalidate, post-check=0, pre-check=0',
      Pragma: 'no-cache',
      Expires: '0',
    }),
  };

  private apiUrl = `${environment.apiUrl}`;
  private _accessTokenKey = 'token';
  private _storedToken = localStorage.getItem(this._accessTokenKey);
  ;

  private router = inject(Router);
  private http = inject(HttpClient);

  login(user: LoginUser): Observable<any> {
    return this.http
      .post<LoginResponse>(`${this.apiUrl}Auth/login`, user).pipe(
        tap((response) => {
            if (response && response.token) {
            localStorage.setItem(this._accessTokenKey, response.token);
            this._storedToken = response.token;                       
          }
        }),)
  }

  isLoggedIn(): boolean {
    this._storedToken = localStorage.getItem(this._accessTokenKey);
    if (!this._storedToken) return false;
    try {
      const decoded: any = jwtDecode(this._storedToken);
      const now = Math.floor(Date.now() / 1000);
      return decoded.exp && decoded.exp > now;
    } catch {
      return false;
    }
  }

  logout(): void {
    localStorage.removeItem(this._accessTokenKey);
    this._storedToken = null;
    this.router.navigate(['auth/login']);
  }
   

  getUsername(): string | null {
    this._storedToken = localStorage.getItem(this._accessTokenKey);
    if (this._storedToken) {
      const decoded: any = jwtDecode(this._storedToken);      
      return decoded.unique_name;
    }
    return null;
  }

  getEmail(): string | null {
    this._storedToken = localStorage.getItem(this._accessTokenKey);
    if (this._storedToken) {
      const decoded: any = jwtDecode(this._storedToken);
      return decoded.email; 
    }
    return null;
  }
}


  

